import { useQuery } from "@tanstack/react-query";
import { ChangeEvent } from "react";
import Dropdown from "./../Dropdown/Dropdown";
import { languagesQuery, Language } from "./../../services/config";

const DEFAULT_OPTION = "Select a language";

type LanguageSelectProps = {
  value?: string | null;
  onChange: (language: Language | undefined) => void;
};

export default function LanguageSelect({ value, onChange }: LanguageSelectProps) {
  const { data: languages = [] } = useQuery(languagesQuery());

  const handleChange = (event: ChangeEvent<HTMLSelectElement>) => {
    onChange(languages.find(language => language.code === event.target.value));
  };

  return (
    <Dropdown
      value={value ?? DEFAULT_OPTION}
      onChange={handleChange}
      className="native-lang-selector"
    >
      <option value={DEFAULT_OPTION}>{DEFAULT_OPTION}</option>
      {languages.map(language => (
        <option key={language.code} value={language.code}>
          {language.native_name + " (" + language.english_name + ")"}
        </option>
      ))}
    </Dropdown>
  );
}
